import { RouterModule } from '@angular/router';
import { PatientComponent } from './patient.component';
import { CreateSEModalComponent } from './create-se-modal/create-se-modal.component';

export const PatientRoutesModule = RouterModule.forChild([
    {
        path: '', redirectTo: '/patients', pathMatch: 'full',
        data: {
            class: 'fluid',
            breadcrumb: 'Patient list'
        }
    },
    {
        path: ':id',
        component: PatientComponent,
        data: {
            alias: 'patient.index',
            reload: false,
            breadcrumb: 'Patient Profile'
        },
        children: [
            {
                path: 'questionnaires',
                component: CreateSEModalComponent,
                data: {
                    type: 'createSEPatientProfile',
                }
            }
        ]
    },
    {
        path: ':patientId/questionnaires',
        component: CreateSEModalComponent,
        data: {
            type: 'createSEPatientProfile',
        }
    },
]);
